<template>
  <main class="privacy">
    <p>{{ msg }}</p>
  </main>
</template>

<script>
  export default {
    name: 'privacy',
    data () {
      return {
        msg: 'Privacy'
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/js/pages/Privacy.vue